import Button from '@atoms/Button/Button';
import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import Text from '@atoms/Text/Text';
import SizeEnum from '@models/enums/SizeEnum';
import { fadeInUpAnimation } from '@utility/config/animations';
import { useListingState } from '@utility/context/ListingContext';
import replaceValuesInLabel from '@utility/helpers/replaceValuesInLabel';
import { AnimatePresence, motion } from 'motion/react';

interface Props {
  readonly loadMoreLabel: string;
  readonly loading: boolean;
  readonly loadingLabel: string;
  readonly resultsLabel: string;
  readonly totalResults: number;
  readonly onLoadMore: () => void;
}

const ListingLoadMoreButton = ({
  loadMoreLabel,
  loading,
  loadingLabel,
  resultsLabel,
  totalResults,
  onLoadMore,
}: Props) => {
  const { showLoadMore, slicedListItems: listItems } = useListingState();

  return (
    <motion.div
      variants={fadeInUpAnimation}
      initial="hidden"
      animate="visible"
      exit="hidden"
      className="tw-flex tw-min-h-[112px] tw-items-center tw-justify-center"
    >
      <AnimatePresence mode="wait">
        {loading ? (
          <div className="tw-col-span-full tw-flex tw-justify-center tw-py-6">
            <LoadingSpinner size={SizeEnum.Small} loadingLabel={loadingLabel} />
          </div>
        ) : (
          <motion.div
            variants={fadeInUpAnimation}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="tw-mt-lg tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center"
          >
            {showLoadMore && (
              <Button
                onClick={onLoadMore}
                variant="grey80"
                modifier="outline"
                label={loadMoreLabel}
              />
            )}
            <Text variant="body-small">
              {replaceValuesInLabel(resultsLabel, [
                listItems ? listItems?.length : 0,
                totalResults,
              ])}
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ListingLoadMoreButton;
